/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {

  $(window).bind('scroll',function(e){
    parallaxScroll();
  });

  function parallaxScroll(){
    var scrolled = $(window).scrollTop();
    $('.home').css('background-position-y', ((70 + scrolled * .30)) + 'px');
    $('.tax-product_cat .category-header-image').css('background-position-y', ((scrolled * -.15)) + 'px');
  }


  //console.log(localStorage);

  $('#logo-header-wrap').on('click', function() {
    window.location = "/";
  });

  $('#home-call-to-action .call-to-action-wrap').fadeTo(0, 1).css({ top: '100px' }, 800);

  $(window).scroll(function() {
    if ($(document).scrollTop() > 115) {
      $('#short-header').css({ top: '0px' });
    }
    else {
      $('#short-header').css({ top: '-55px' });
    }
  });

  var icon = document.querySelector("header .menu_icon");
  icon.addEventListener("click", function () {
    icon.classList.toggle('clicked');
    $('#mobile-menu').toggleClass('active');
  });

  $(window).scroll(function() {
    if ($(this).scrollTop() > 145) {
      $('#back-to-top').addClass('active');
    } else {
      $('#back-to-top').removeClass('active');
    }
  });

  $('#back-to-top').click(function() {
    $('html, body').animate({
        scrollTop: $('header').offset().top
    }, 1200);
  });

  $('.wpfFilterButtons button').addClass('button secondary');

});
